import { RoleTranslate } from './roleTranslate.model';

const roleTranslatePTBR: RoleTranslate = {
  administrator: 'Administrador',
  manager: 'Gerente',
  member: 'Membro',
};

export default roleTranslatePTBR;
